import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import ExtratoService from "../../service/financeiro/ExtratoService";
import { useToastContext } from "../../provider/ToastContext";

type Props = {
    visible: boolean;
    onHide: () => void;
}

const service = new ExtratoService();
export default function EscolherAnoImpostoDialog({ visible, onHide }: Props) {
    const [ano, setAno] = useState<number | null>(null);
    const { msgAlerta, msgErro } = useToastContext();

    const handleConfirm = () => {
        service.buscarInformeImpostoRenda(ano || 0).then(response => {
            if (response == null) {
                msgAlerta("Informe indisponível", "Informe de imposto de renda não disponível para o ano selecionado.");
                return;
            }
            window.open(response.urlReport, '_blank');
            onHide();
        }).catch(err => {
            if(err.data && err.data.message){
                msgErro("Erro ao gerar informe", err.data.message);
                return;
            }
            msgErro("Erro ao gerar informe", "Ocorreu um erro ao tentar gerar o informe de imposto de renda.");
            console.log(err);
        });
    }

    return (
        <Dialog
            header={<div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                Escolha o ano para gerar o informe do imposto de renda
            </div>}
            visible={visible}
            style={{ width: "450px" }}
            onHide={() => onHide()}
            footer={
                <div>
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        outlined
                        className="p-button-text"
                        onClick={() => onHide()}
                    />
                    <Button
                        label="Gerar"
                        disabled={!ano}
                        icon="pi pi-check"
                        onClick={() => handleConfirm()}
                    />
                </div>
            }
        >
            <div>
                <InputText
                    type="number"
                    value={ano !== null ? ano + "" : ''}
                    onChange={(e) => setAno(e.target.value ? parseInt(e.target.value) : null)}
                    placeholder="Ano"
                />
            </div>
        </Dialog>
    )
}